import { CLEAR_FILES } from '../actionTypes'

export const clearFiles = { type: CLEAR_FILES }
